import { sanitizeStorePreferenceIds } from "./storePreferences";

export const NEAREST_STORE_SHORTLIST_LIMIT = 4;

/**
 * A standard search now includes every supported retailer with an actual
 * nearby location, in distance order. Unverified national chains remain
 * excluded upstream. A user can narrow their choice in the store selector.
 */
export function pickDefaultNearbyGrocers(retailerIds: readonly string[]): string[] {
  return sanitizeStorePreferenceIds([...retailerIds]);
}

/** An optional action to reduce an existing search to the four closest chains. */
export function pickNearestNearbyGrocers(
  retailerIds: readonly string[],
): string[] {
  return pickDefaultNearbyGrocers(retailerIds).slice(0, NEAREST_STORE_SHORTLIST_LIMIT);
}

/** Explicitly selected chains must still have a verified nearby location. */
export function scopeStoreSelectionToNearby(
  requested: readonly string[],
  nearby: readonly string[],
): { included: string[]; excluded: string[] } {
  const nearbySet = new Set(sanitizeStorePreferenceIds([...nearby]));
  const uniqueRequested = sanitizeStorePreferenceIds([...requested]);
  return {
    included: uniqueRequested.filter((id) => nearbySet.has(id)),
    excluded: uniqueRequested.filter((id) => !nearbySet.has(id)),
  };
}
